export default __webpack_public_path__ + "static/media/PAK.ffd6654c.svg";